import { render, staticRenderFns } from "./Clause.vue?vue&type=template&id=78697fe8&scoped=true&"
import script from "./Clause.vue?vue&type=script&lang=js&"
export * from "./Clause.vue?vue&type=script&lang=js&"
import style0 from "./Clause.vue?vue&type=style&index=0&id=78697fe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78697fe8",
  null
  
)

export default component.exports